import api from '@/services/api'

export interface RoutingSettings {
  autoAssignToAgent: boolean
  maxOpenConversationsPerAgent: number
  autoCloseEnabled: boolean
  autoCloseInactivityMinutes: number
}

export async function getRoutingSettings(): Promise<RoutingSettings> {
  const { data } = await api.get<RoutingSettings>('/routing/settings')
  return data
}

export async function updateRoutingSettings(payload: Partial<RoutingSettings>): Promise<RoutingSettings> {
  const { data } = await api.put<RoutingSettings>('/routing/settings', payload)
  return data
}
